import { render, staticRenderFns } from "./ModifyNickname.vue?vue&type=template&id=633578e6&scoped=true&"
import script from "./ModifyNickname.vue?vue&type=script&lang=js&"
export * from "./ModifyNickname.vue?vue&type=script&lang=js&"
import style0 from "./ModifyNickname.vue?vue&type=style&index=0&id=633578e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633578e6",
  null
  
)

export default component.exports